module.exports = "<app-loading *ngIf=\"loading\"></app-loading>\n<app-tarjetas [tarjetaData]=\"newReleases\"></app-tarjetas>\n"